// @ts-strict-ignore
import React, { HTMLAttributes, useEffect, useState } from 'react'
import { makeStyles } from 'tss-react/mui'
import { v4 as uuid } from 'uuid'
import { trackError } from 'services/analytics'
import { useFocusFadeGroupContext } from './FocusFadeGroupContext'

const useStyles = makeStyles()({
  container: {
    transition: 'opacity 0.2s ease',
  },
})

interface IFocusFadeGroupProps extends HTMLAttributes<HTMLDivElement> {
  focused?: boolean
}

function FocusFadeGroup(props: IFocusFadeGroupProps) {
  const { focused, children, style = {}, ...restProps } = props
  const [isBlurred, setIsBlurred] = useState<boolean>(false)
  const { focusedComponentID, setFocusedComponentID } = useFocusFadeGroupContext()

  const { classes } = useStyles()
  const [componentID] = useState(uuid())

  if (!useFocusFadeGroupContext()) {
    if (process.env.NEXT_PUBLIC_APP_ENV === 'development') {
      throw new Error('FocusFadeGroup found no Provider.')
    } else {
      trackError(new Error('FocusFadeGroup found no Provider.'))
    }
  }

  useEffect(() => {
    if (focused) {
      setFocusedComponentID(componentID)
      setIsBlurred(focusedComponentID !== componentID)
    }

    return () => {
      if (focusedComponentID === componentID) {
        setFocusedComponentID(null)
      }
    }
  }, [componentID, focused, focusedComponentID, isBlurred, setFocusedComponentID])

  useEffect(() => {
    setIsBlurred(focusedComponentID !== null && focusedComponentID !== componentID)
  }, [componentID, focusedComponentID])

  let computedStyle = isBlurred ? { opacity: 0.4, ...style } : style

  return (
    <div style={computedStyle} className={classes.container} {...restProps}>
      {children}
    </div>
  )
}

export default FocusFadeGroup
